import React from 'react';
import StrikethroughSIcon from '@material-ui/icons/StrikethroughS';
import MarkButton from './MarkButton';

function StrikeThroughButton() {
  return <MarkButton format="strike_through" Icon={<StrikethroughSIcon fontSize="small" />} />;
}

export default StrikeThroughButton;
